export class FilterBase {
  ShowActiveAndInActiveItems: boolean;
  Name: string;

  constructor(name?: string) {
    this.ShowActiveAndInActiveItems = false;
    this.Name = null;

    if (name) {
      this.Name = name;
    }
  }
}
